/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SHOW_ANTIBURN_OSD = 'SHOW_ANTIBURN_OSD';
export const HIDE_ANTIBURN_OSD = 'HIDE_ANTIBURN_OSD';
export const UPDATE_ANTIBURN_TIMER = 'UPDATE_ANTIBURN_TIMER';
export const SET_PARENTAL_CHECK_ON_ANTIBURN_OSD = 'SET_PARENTAL_CHECK_ON_ANTIBURN_OSD';
